import React from 'react';
import { motion } from 'framer-motion';
import { WhatsAppButton } from './WhatsAppButton';
import { ShieldCheck } from 'lucide-react';
export function FinalCTA() {
  return <section className="relative py-32 px-4 sm:px-6 lg:px-8 overflow-hidden border-t border-mystic-gold/20" data-id="element-65">
      {/* Dramatic Background Effects */}
      <div className="absolute inset-0 bg-mystic-black z-0" data-id="element-66"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-full bg-mystic-gold/10 blur-[120px] rounded-full z-0" data-id="element-67"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] bg-mystic-blue-800/30 blur-[100px] rounded-full z-0" data-id="element-68"></div>

      {/* Subtle star/particle effect using CSS pattern */}
      <div className="absolute inset-0 opacity-20 mix-blend-screen z-0" style={{
      backgroundImage: 'radial-gradient(circle at center, #D4AF7A 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }} data-id="element-69"></div>

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-71">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-bold mb-6 leading-tight" data-id="element-72">
            La claridad que buscas puede{' '}
            <span className="text-gradient-gold" data-id="element-73">comenzar hoy</span>
          </h2>

          <p className="text-xl text-mystic-white/80 mb-12 max-w-2xl mx-auto font-light leading-relaxed" data-id="element-74">
            Recibe orientación personalizada y descubre las energías que pueden
            estar influyendo en tu vida, tu hogar o tu negocio.
          </p>

          <div className="flex flex-col items-center gap-6" data-id="element-75">
            <WhatsAppButton text="Hablar por WhatsApp ahora" variant="large" message="Hola Maestro Navy, estoy listo/a para comenzar y me gustaría agendar una consulta." data-id="element-76" />

            <div className="flex items-center gap-2 text-mystic-white/60 text-sm font-medium mt-4" data-id="element-77">
              <ShieldCheck className="w-4 h-4 text-mystic-gold" data-id="element-78" />
              <span data-id="element-79">Respuesta rápida y atención personalizada.</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}